import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':toolId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:toolId`;

export const URL = (toolId: number): RouteDefinition => `${baseRoute}/${toolId}`;
